import { ICreateImportTemplate, IImportTemplate, ISimpleDriverDTO } from '../types'
import Paths from '../utils/paths'
import { serverApi } from '../utils/request'

class GroupRideService {
  public async assignOperator(id: string, operator: ISimpleDriverDTO) {
    try {
      const resp: any = await serverApi.post(Paths.groupRides.assignOperator.replace(':id', id), operator)
      return resp.data
    } catch (e) {
      throw e.data
    }
  }

  public async unAssignOperator(id: string) {
    try {
      const resp: any = await serverApi.post(Paths.groupRides.unAssignOperator.replace(':id', id))
      return resp.data
    } catch (e) {
      throw e.data
    }
  }
}

const groupRideService = new GroupRideService()

export { groupRideService }



// WEBPACK FOOTER //
// ./src/services/GroupRide.ts